import { useNavigate } from 'react-router-dom';

export const useNavigation = () => {
    const navigate = useNavigate();

    const handleDashboardClick = () => navigate('/dashboard');
    const handleWhatsappClick = () => navigate('/whatsapp');
    const handleBankClick = () => navigate('/bank');

    return {
        handleDashboardClick,
        handleWhatsappClick,
        handleBankClick
    };
}; 
